import PromiseLock from './PromiseLock';

const checkoutLock = new PromiseLock();

export default checkoutLock;
